// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy-policy_container__LLo1o","inner":"privacy-policy_inner__5aIm7","fade-in":"privacy-policy_fade-in__gfNBK"};